// caseSupervision
const AppPeace = () => import("@/layout/AppPeace.vue");
const caseSupervision = () => import("@/views/caseSupervision/caseSupervision.vue");
export default {
  path: "/",
  component: AppPeace,
  sort: 3,

  children: [
    {
      path: "/caseSupervision",
      name: "caseSupervision",
      component: caseSupervision,
    },
  ],
};
